import './AdminBottomNav.scss';

import {
  faCalendarDays,
  faClipboardList,
  faGear,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import React from 'react';

const items = [
  { to: '/relatorio-geral', label: 'Financeiro', icon: faWallet },
  { to: '/relatorio', label: 'Comandas', icon: faClipboardList },
  { to: '/agenda', label: 'Agenda', icon: faCalendarDays },
];

export default function AdminBottomNav() {
  return (
    <nav className="admin-bottom-nav" aria-label="Menu rápido do administrador">
      <div className="admin-bottom-nav__inner">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            className={({ isActive }) =>
              `admin-bottom-nav__item ${isActive ? 'admin-bottom-nav__item--active' : ''}`
            }
          >
            <span className="admin-bottom-nav__icon" aria-hidden="true">
              <FontAwesomeIcon icon={it.icon} />
            </span>
            <span className="admin-bottom-nav__label">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
